var _circle, _rect, _line, _rect2, _line2, _rect3, _line3, _rect4, _line4, _rect5, _line5, _rect6, _line6, _rect7, _line7, _rect8, _line8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanquet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 6,
    fill: "#6E6B7B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#6E6B7B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 1.2998,
    x2: 13.5,
    y2: 1.2998,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(1 0 0 -1 11 21.7998)",
    fill: "#6E6B7B"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(1 0 0 -1 11 22)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4396,
    y: 3.83911,
    width: 3,
    height: 3,
    rx: 1,
    transform: "rotate(45 18.4396 3.83911)",
    fill: "#6E6B7B"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.2883,
    y1: 3.69751,
    x2: 20.7025,
    y2: 5.11172,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 4.43903 17.8396)",
    fill: "#6E6B7B"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 4.29749 17.9812)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3999,
    y: 10.5,
    width: 3,
    height: 3,
    rx: 1,
    transform: "rotate(90 22.3999 10.5)",
    fill: "#6E6B7B"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 23.1001,
    y1: 11,
    x2: 23.1001,
    y2: 13,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 2.6001 10.5)",
    fill: "#6E6B7B"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 2.3999 10.5)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.561,
    y: 17.9397,
    width: 3,
    height: 3,
    rx: 1,
    transform: "rotate(135 20.561 17.9397)",
    fill: "#6E6B7B"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 20.7025,
    y1: 18.7884,
    x2: 19.2883,
    y2: 20.2026,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 3,
    rx: 1,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 6.56036 3.93921)",
    fill: "#6E6B7B"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 2.5,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 6.41882 3.79761)",
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanquet);
export default __webpack_public_path__ + "static/media/banquet.77a0a7b9dd60a023b8a3a9352a5276c5.svg";
export { ForwardRef as ReactComponent };